import { Vue, Component } from 'vue-facing-decorator';

@Component
export class CurrencyMixin extends Vue {
    /**
     * Formats a number to Swiss currency format: 1'900.00
     * @param value The number to format
     * @returns A formatted string or '0.00' if value is null/undefined
     */
    public formatSwissCurrency(value: number | null | undefined): string {
        if (value === null || value === undefined || isNaN(value)) {
            return '0.00';
        }

        // Use Intl.NumberFormat for robust formatting
        // We'll replace the thousands separator with ' as standard Swiss formatting often uses it
        // and some environments might use a space or different character.
        const formatter = new Intl.NumberFormat('de-CH', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });

        return formatter.format(value).replace(/\u2019/g, "'").replace(/\s/g, "'");
    }

    /**
     * Parses a Swiss currency string back to a number
     * @param value The string to parse (e.g., "1'900.00")
     * @returns A number or 0 if parsing fails
     */
    public parseSwissCurrency(value: string | null | undefined): number {
        if (!value) {
            return 0;
        }

        // Remove thousands separator (') and ensure dot is used for decimal
        const cleanValue = value.replace(/'/g, '');
        const parsed = parseFloat(cleanValue);

        return isNaN(parsed) ? 0 : parsed;
    }
}
